import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { useToggle } from "ahooks";
import BreadCrumb from "@/app/csr-src/components/breadCrumb";
import SideMenu from "@/app/csr-src/components/sideMenu";
import { useStores } from "@/app/csr-src/models";
import withHeaderFooter, { IWithHeaderFooterProps } from "@/app/csr-src/hocs/with-header-footer";
import styles from "./index.module.scss";
import HistoryIcon from "@/assets/icons/HistoryIcon2.svg";

const OrderList = withHeaderFooter(
  observer(({ JDIHeader }: IWithHeaderFooterProps) => {
    const { t, i18n } = useTranslation();
    const { orderStore } = useStores();
    const [isShowImportantOnly, { toggle }] = useToggle(false);

    const loadOrderList = () => {
      const orderInfo = sessionStorage.getItem("orderInfo") || "{}";
      const orderInfoObj = JSON.parse(orderInfo);
      orderInfoObj.pageNum && orderStore.setPageNum(orderInfoObj.pageNum);
      orderInfoObj.orderType && orderStore.setOrderType(orderInfoObj.orderType);
      orderStore.getOrderList({
        page: orderInfoObj.pageNum
          ? String(orderInfoObj.pageNum)
          : orderStore.pageNum
            ? String(orderStore.pageNum)
            : "1",
        state: orderInfoObj.orderType ? orderInfoObj.orderType : orderStore.orderType || "4096",
      });
    };

    useEffect(() => {
      loadOrderList();
    }, []);

    // useEffect(() => {
    //   const orderInfo = sessionStorage.getItem("orderInfo") || "{}";
    //   const orderInfoObj = JSON.parse(orderInfo);
    //   setTimeout(() => {
    //     const orderList = orderStore?.orderListInfo?.orderInfoDTOS || [];
    //     const pageHeight = document.documentElement.scrollHeight;
    //     console.log(orderList.length, document.documentElement.scrollHeight);
    //     if (
    //       orderList.length &&
    //       !orderStore?.error &&
    //       orderInfoObj.scrollY > 436 &&
    //       orderInfoObj.scrollY <= pageHeight
    //     ) {
    //       console.log(orderInfoObj.scrollY, 23233);
    //       window.scrollTo(0, orderInfoObj.scrollY); // 页面跳转时滚动到顶部
    //     } else {
    //       console.log(55645666);
    //       window.scrollTo(0, 0); // 页面跳转时滚动到顶部
    //     }
    //   }, 600);
    // }, []);

    useEffect(() => {
      window.scrollTo(0, 0); // 页面跳转时滚动到顶部
    }, []);

    const initCartNumHandler = () => {
      JDIHeader?.current?.initCartNum();
    };

    // useEffect(() => {
    //   const lang = isShowImportantOnly ? "zh_CN" : "en_US";
    //   i18n.changeLanguage(lang);
    // }, [isShowImportantOnly]);

    const nameStr = "343";
    return (
      <div className={styles.order_outer_wrap}>
        <button onClick={toggle}>switch</button>
        <div className={styles.order_wrap}>
          <BreadCrumb list={[{ name: "Me" }, { name: "My orders" }]} />
          <div className={styles.main_wrap}>
            <SideMenu />
            <div className={styles.order_content}>
              <div className={styles.order_title_wrap}>
                <div className={styles.order_title}>
                  <img src={t("demo.demoList.iconPath")} />
                  <Trans
                    i18nKey="demo.demoList.icon"
                    components={{
                      strong: <HistoryIcon />,
                      a: (
                        <a
                          href="/download"
                          style={{ color: "blue", textDecoration: "underline" }}
                        />
                      ),
                    }}
                    // values={{ username: "Tim" }}
                  />
                </div>
                <div className={styles.order_title}>
                  {t("demo.demoTitle", { name: nameStr, title: "44" })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }),
);

export default OrderList;
